<div style="display:flex; align-items: center; height: 100%" *ngIf="!params.node.rowPinned">
    <i class="material-icons" (click)="btnClickedHandler($event)">edit</i>
<div>